import { contains } from 'ramda';

const utils = {
  withQueryParams,
  isLoggedInUserOfType,
};

function withQueryParams(obj, param) {
  obj[`filters[${param[0]}]`] = param[1];
  return obj;
}

function isLoggedInUserOfType(type, types) {
  const ts = Array.isArray(types)
    ? types
    : [types];
  return contains(type, ts);
}

export default utils;
